import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss']
})
export class ReceiptComponent implements OnInit {

  items: any = [];
  isLoading = false;
  Errors = null;
  data = null;
  templates;
  id;
  receipt;
  templateText

  htmlContent = "";

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '300px',
      minHeight: '300px',
      maxHeight: '300px',
      width: 'auto',
      minWidth: 'auto',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
      ]
    ],
};

// Form = new FormGroup({
//   Mode: new FormControl('RECEIPT', Validators.required),
//   DocTemplateId: new FormControl('', Validators.required),
//   Receiver: new FormControl('', Validators.required),
//   Subject: new FormControl('', Validators.required),
//   MessageBody: new FormControl('', Validators.required),
// });
templateForm = new FormGroup({
  Id: new FormControl(184, Validators.required),
  Mode: new FormControl('RECEIPT', Validators.required),
  Name: new FormControl('', Validators.required),
  Item_Of_Service_Id: new FormControl('', Validators.required),
  Template_Text: new FormControl('', Validators.required),
});

  // templates = [
  //   {
  //     name: "Deployment",
  //     message: `<div style="text-align: center;"><b>LETTER FOR DEPLOYMENT</b></div><div style="text-align: center;"><b><br></b></div><div><br></div>dear [[Name]],<div>You have been deployed to [[LocationName]],</div><div><br></div><div><br></div><div>Effective Date: [[StartDate]],</div><div><br></div><div><br></div><div>Administrator</div><div>[[Organization]]</div>`,
  //   },
  //   {
  //     name: "birthday",
  //     message: `<div style="text-align: center;"><br></div><div><br></div>dear [[Name]],<div>On this special day of yours, we want to wish you a happy birthday,</div><div><br></div><div><br></div><div>Thank You,</div><div><br></div><div><br></div><div>Signed</div><div>Management</div>`,
  //   }
  // ];


  constructor(public auth: SettingsService, private _snackBar: MatSnackBar) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    console.log(this.templateForm.value)
    const {
      Id,
      Mode,
      Name,
      Item_Of_Service_Id,
      Template_Text,
    } = this.templateForm.value;
    this.auth
      .EditReceipt(
        Id,
        Mode,
        Name,
        Item_Of_Service_Id,
        Template_Text,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            }); 
          }
          else {
            this.isLoading = false;
            this._snackBar.open('Error please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });            
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false; 
          this._snackBar.open('Error please check your internet and try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });          
          console.log(resErr)
        }
      );
  }
  // Submit(e) {
  //   e.preventDefault();
  //   this.isLoading = true;
  //   this.Errors = null;
  //   console.log(this.Form.value)
  //   const {
  //     DocTemplateId,
  //     Mode,
  //     Receiver,
  //     Subject,
  //     MessageBody,
  //   } = this.Form.value;
  //   this.auth
  //     .sendDoc(
  //       DocTemplateId,
  //       Mode,
  //       Receiver,
  //       Subject,
  //       MessageBody,
  //     )
  //     .subscribe(
  //       (resSuccess) => {

  //         this.data = resSuccess
  //         this.isLoading = false;

  //         if (this.data.success) {
  //           this._snackBar.open('Sent Successfully', '', {
  //             duration: 2000,
  //             verticalPosition: 'top',
  //           }); 
  //         }
  //         else {
  //           this.isLoading = false;
  //           this.Errors = "Not successful, please try again"
  //           console.log(resSuccess)
  //         }
          
  //       },
  //       (resErr) => {
  //         this.isLoading = false; 
  //         this.Errors = resErr;
  //         console.log(resErr)
  //       }
  //     );
  // }

  ngOnInit(): void {

    this.auth
      .getItems()
      .subscribe(
        (resSuccess) => {

          this.items = resSuccess
        },
        (resErr) => {
        } 
      );

      this.auth
      .getReceipt()
      .subscribe(
        (resSuccess) => {

          this.receipt = resSuccess
          this.templateText = this.receipt.Template_Text
          console.log(this.templateText)
          this.templateForm.patchValue({
            Template_Text: this.templateText,
            Name: this.receipt.Name
          });
        },
        (resErr) => {
        } 
      );

      this.auth
      .gettemplates()
      .subscribe(
        (resSuccess) => {

          this.templates = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        } 
      );
  }

  // setTemplate(template) {
  //   this.Form.patchValue({
  //     MessageBody: template.Template_Text,
  //   });
  // }


}
